import React from 'react';
import { marketplaceBenefitsData } from '../../data/marketplaceData';
import { Settings, Calculator, Eye, TrendingUp, Users, Rocket, ArrowRight } from 'lucide-react';

const iconMap = {
  Settings,
  Calculator,
  Eye,
  TrendingUp,
  Users,
  Rocket
};

const MarketplaceBenefits = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#8bcaf9]/20 text-[#1297fd] rounded-full text-sm font-medium mb-4">
            Beneficios
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Logra control financiero de{' '}
            <span className="text-[#1297fd]">tu negocio</span>
          </h2>
          <p className="text-lg text-[#c3c3c5] max-w-3xl mx-auto">
            Un SaaS marketplace simplifica ventas de suscripciones reduciendo carga operativa y mejorando control financiero.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {marketplaceBenefitsData.map((benefit, idx) => {
            const IconComponent = iconMap[benefit.icon];
            const isHighlighted = idx === 0 || idx === 3;
            
            return (
              <div
                key={benefit.id}
                className={`group relative rounded-3xl p-8 transition-all duration-500 hover:-translate-y-2 ${
                  isHighlighted
                    ? 'text-white shadow-xl shadow-[#1297fd]/20'
                    : 'bg-white border border-[#e3e4e6] hover:border-[#8bcaf9] hover:shadow-xl hover:shadow-[#1297fd]/10'
                }`}
                style={isHighlighted ? { background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' } : {}}
              >
                {/* Icon */}
                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-6 transition-all duration-300 group-hover:scale-110 ${
                  isHighlighted
                    ? 'bg-white/20'
                    : 'bg-[#8bcaf9]/20'
                }`}>
                  {IconComponent && (
                    <IconComponent className={`w-7 h-7 ${
                      isHighlighted ? 'text-white' : 'text-[#1297fd]'
                    }`} />
                  )}
                </div>

                {/* Content */}
                <h3 className={`text-xl font-bold mb-3 ${
                  isHighlighted ? 'text-white' : 'text-gray-900'
                }`}>
                  {benefit.title}
                </h3>
                <p className={`leading-relaxed ${
                  isHighlighted ? 'text-white/80' : 'text-[#c3c3c5]'
                }`}>
                  {benefit.description}
                </p>

                {/* Decorative */}
                <div className={`absolute top-0 right-0 w-24 h-24 rounded-bl-full opacity-10 ${
                  isHighlighted ? 'bg-white' : 'bg-[#1297fd]'
                }`} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MarketplaceBenefits;
